// AJAX CART

//DOM ELEMENTS

// Add To Cart Form - used throughout website so will work for all.
const addToCartForm = document.querySelectorAll('#product-form');

// Add To Cart Form Upsells - used throughout website so will work for all.
const addonForm = document.querySelectorAll('#addon-form');

//Slide Cart Wrapper
const slideCartWrapper = document.querySelector('.slide-cart-wrapper');

addToCartForm.forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const btn = form.querySelector('#addToCartButton');
    btn.textContent = "ADDING..";

    await fetch("/cart/add", {
      method: "POST",
      body: new FormData(form),
    });

    updateHeaderCartCount();
    updateSlideCart();
    openSlideCart();

    btn.textContent = "ORDER NOW";

    document.querySelector('.header-cart-item-count').style.display = "block";
  });
});

// Open Slide Cart
function openSlideCart() {
  slideCartWrapper.classList.add("slide-cart--active");
  document.body.style.overflowY = "hidden";
}

// Close Slide Cart
function closeSlideCart() {
  slideCartWrapper.classList.remove("slide-cart--active");
  document.body.style.overflowY = "scroll";
}

// Update Cart Count in Header
async function updateHeaderCartCount() {
  // Get New Cart Object
    const res = await fetch("/cart.json");
    const cart = await res.json();

  document.querySelectorAll(".header-cart-item-count").forEach(el => {
    el.textContent = cart.item_count;
  });
}

// Slide Cart Listeners
  async function slideCartListeners() {

  // Update Quantity Input
  document.querySelectorAll('.slide-cart-quantity button').forEach((button) => {
    button.addEventListener('click', async () => {
      // Get Line item Key
      const rootLineItem = button.closest("#slide-cart-item").getAttribute("slide-cart-line-item-key");
      
      // Get New Quantity to Check Inventory
      const currentQty = Number(button.parentElement.querySelector('input[name="updates[]"]').value);
      const isUp = button.classList.contains('quantity-plus');
      const newQty = isUp ? currentQty + 1 : currentQty - 1;
        
      // Update QTY with AJAX
      const res = await fetch('/cart/update.js', {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [rootLineItem]: newQty } }),
      });

      // Update Slide Cart
      updateSlideCart();

      // Update Header Cart Count
      updateHeaderCartCount();
    });
  });

  // Remove Product - MOVED OUTSIDE of quantity button loop
  document.querySelectorAll(".slide-cart-remove").forEach((remove) => {
    console.log(remove);
    remove.addEventListener("click", async (e) => {
      e.preventDefault();
      console.log("clicked remove");
      const item = remove.closest(".slide-cart-item");
      const key = item.getAttribute('slide-cart-line-item-key');
      await removeItem(key, 0, item);
    });
  });

  // Stop Inner Slide Cart closing cart
  document.querySelector(".slide-cart-inner-wrapper")?.addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // Close Slide Cart
  document.querySelectorAll(".slide-cart-close, .slide-cart-wrapper").forEach((close) => {
    close.addEventListener("click", () => {
      closeSlideCart();
    });
  });

}

// Move removeItem function outside of slideCartListeners
async function removeItem(key, quantity, item) {
  try {
    // Remove with AJAX
    const res = await fetch('/cart/update.js', {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [key]: quantity } }),
    });

    const cart = await res.json();

    if (cart.items.length === 0) {
      closeSlideCart();
      updateSlideCart();
      updateHeaderCartCount();
    } else {
      updateHeaderCartCount();
      const format = document.querySelector('[data-money-format]').getAttribute('data-money-format');
      const totalPrice = formatMoney(cart.total_price, format);
      document.querySelector(".checkout-price").textContent = totalPrice;
      item.remove();
    }
  } catch (error) {
    console.error('Error removing item:', error);
  }
}


slideCartListeners();

document.addEventListener('DOMContentLoaded', () => {
  const clearAllLink = document.querySelector('.slide-cart-remove-all a');
  if (!clearAllLink) return;

  clearAllLink.addEventListener('click', async (e) => {
    e.preventDefault();

    // 1) clear the cart via AJAX
    await fetch('/cart/clear', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });

    // 2) update your UI
    updateHeaderCartCount();
    closeSlideCart();

    // 3) redirect back to campaign product
    window.location.href = '/products/slasher-trash';
  });
});

// Open Slide Cart
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
      e.preventDefault();
      openSlideCart();
  })
})

// Update Slide Cart Inner Item HTML
  async function updateSlideCart() {
  const res = await fetch("/?section_id=template-kickstarter-slide-cart");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newItems = html.querySelector(".slide-cart-wrapper").innerHTML;
  slideCartWrapper.innerHTML = newItems;
  slideCartListeners();
  addOn();
}

// Add-On Form - used throughout website so will work for all.
addOn();

// Addon Form Submit (within slide out cart)
function addOn() {
  const addonForm = document.querySelectorAll('#addon-form');
  
  addonForm.forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
    
      form.querySelector('.addon-cart-text').textContent = "ADDING...";
    
      // Submit the form with AJAX
        await fetch("/cart/add", {
          method: "POST",
          body: new FormData(form),
        });
    
      // Get New Cart Object
        const res = await fetch("/cart.json");
        const cart = await res.json();

      //Update Cart Count Header
        updateHeaderCartCount();
      
      // Update Slide Cart
        updateSlideCart();

      // Rename Button
        form.querySelector('.addon-cart-text').textContent = "ADD TO CART";

      // Update Slide Cart
        openSlideCart();
      
    });
  });
};